// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"6":"66353cc0a3a65da4","507":"a95a75561c8f7b24"}[chunkId] + ".js";
};